import { Component, OnInit, Compiler } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Report, RowActions } from "../../../../admin/report/report";
import { PasswordConfirmComponent } from "../../../../../shared/components/password-confirm/password-confirm.component";
import { DeleteAccountService } from "../../services/delete-account.service";
import { ListBankAccountsService } from "../../services/list-accounts.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../../../../shared/services/language.service";
import { BankAccountAddedNotifierService } from "../../../my-account/components/new-contract-page/BankAccountAddedNotifier.service";

@Component({
  selector: "app-bank",
  templateUrl: "./bank.component.html",
  styleUrls: ["./bank.component.scss"]
})
export class BankComponent implements OnInit {
  formValidator: FormValidatorService = new FormValidatorService();
  Columns: any[] = [
    "holder_name",
    "english_branch_name",
    "bank_name",
    "account_number",
    "arabic_bank_name",
    "type"
  ];
  displayTableColumns = {};

  rowActions: RowActions[] = [
    {
      actionName: "delete",
      actionType: "icon",
      iconClass: "fa-trash"
    }
  ];
  filterField = []
  totalNumberOfRecords: number = 0;
  bankAccountReportData: any[] = [];
  reportName: string = '';

  constructor(
    public listBankAccounts: ListBankAccountsService,
    private deleteAccountService: DeleteAccountService,
    private bankAccoundAddedNotifier: BankAccountAddedNotifierService,
    public dialog: MatDialog,
    private compiler: Compiler,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    this.compiler.clearCache();
  }

  requestBody: Report = {};
  loading = false;
  isBank = true;
  async ngOnInit() {
    this.bankAccoundAddedNotifier.getStatusNotification().subscribe(()=>{
      this.updateTable();
    });
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.listBankAccounts.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }
  loadArContent() {
    this.reportName = 'الحسابات البنكية';
    this.translate.use('ar');

    this.displayTableColumns = {
      holder_name: "اسم صاحب الحساب",
      english_branch_name: "اسم الفرع",
      bank_name: "اسم البنك",
      account_number: "IBAN / Wallet Number",
      arabic_bank_name: "اسم البنك بالعربي",
      type:"نوع الحساب"
    };
  }

  loadEnContent() {
    this.reportName = 'Bank Accounts';
    this.translate.use('en');

    this.displayTableColumns = {
      holder_name: "Holder Name",
      english_branch_name: "Branch Name",
      bank_name: "Bank Name",
      account_number: "IBAN / Wallet Number",
      arabic_bank_name: "arabic bank name",
      type: "type"
    };
  }

  async deleteAccount(account_id: any) {
    try {
      const confirmPasswordData = new MatDialogConfig();
      confirmPasswordData.data = {
        showOtp: false
      }
      const dialogRef = this.dialog.open(PasswordConfirmComponent, confirmPasswordData);
      const dialogResult = await dialogRef.afterClosed().toPromise();
      if (!dialogResult?.status) {
        return;
      }
      const params = {
        account_id: account_id
      };
      this.deleteAccountService.setParams(params);
      await this.deleteAccountService.make();
      this.updateTable();
      this.listBankAccounts.loader().subscribe((val: any) => (this.loading = val));
    } catch (err) {
      console.log(err);
    }
  }

  onRowAction(event: any) {
    if (event.action === "delete") {
      this.deleteAccount(event.key.id);
    }
  }

  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.listBankAccounts.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
    this.listBankAccounts.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChance($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.listBankAccounts.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.listBankAccounts.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.listBankAccounts.activateLoader();
    this.listBankAccounts.setParams(this.requestBody);
    const report = await this.listBankAccounts.make();
    this.bankAccountReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
}
